import { useCallback, useEffect } from "react";
import { useFormList } from "./useFormList";
import { useFormConclued } from "./useFormConclued";
import { getDataFormByKey } from "../helpers/formCommentsHelpers";

export const useCommentList = ({
    nameList,
    rules,
    reasons,
}) => {

    const {
        form,
        actionsComments,
        fieldCheck: {
            checkAll,
            onChangueSelectAll,
            updateRefChecked
        },
        fieldButton: {
            buttonsCheked,
            updateButtons,
            updateButtonsByForm
        }
    } = useFormConclued()

    const {
        updateChecked,
        updateFormByChecked,
        updateInitForm
    } = useFormList(form)

    const isBlockNewComment = !buttonsCheked.every(valor => valor)
    const indexEditButton = buttonsCheked.findIndex((value) => !value)

    const updateSelectAndButtons = useCallback(({ value = false, idChild, isDelete = false }) => {
        onChangueSelectAll({ value, idChild, isDelete });
        updateButtons({ value, idChild, isDelete });
    }, [onChangueSelectAll, updateButtons]);

    const handleAddComment = useCallback((add, index) => {
        if (rules?.isAddComment) return;
        add();
        updateSelectAndButtons({ value: false, idChild: index });
    }, [rules, updateSelectAndButtons]);

    const handleDeleteComment = useCallback(async (remove, name, fields) => {
        if (rules?.lengthNumber === fields.length) return;

        const deleteData = await actionsComments.deleteComment({ idChild: name })

        if (!deleteData) return

        remove(name);
        updateSelectAndButtons({ idChild: name, isDelete: true });

    }, [rules, updateSelectAndButtons, actionsComments]);

    const handleSaveComment = useCallback(async (name) => {
        if (isBlockNewComment && indexEditButton !== name) return;

        const isUpdate = await actionsComments.updateComment({ idChild: name, isEdit: !buttonsCheked[name] })

        if (!isUpdate) return

        updateButtons({ idChild: name, value: !buttonsCheked[name] });
    }, [isBlockNewComment, indexEditButton, buttonsCheked, updateButtons, actionsComments]);

    const handleSelectChange = useCallback((name, value) => {
        onChangueSelectAll({ value, idChild: name });
        updateFormByChecked({ idChild: name, items: value ? reasons.items : [] });
    }, [onChangueSelectAll, updateFormByChecked, reasons]);


    useEffect(() => {
        const { key, data } = getDataFormByKey(form)

        if (key === 'comentarios' && data.length === 0) {
            form.setFieldsValue({ [key]: [{ comment: "", reason: [] }] });
        }

        updateChecked({ nameList, updateRefChecked, updateButtonsByForm, items: reasons.items.length })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameList])


    useEffect(() => {
        if (!rules?.isAddComment && nameList === "cotizacion") {
            updateInitForm({ value: [{ comment: "", reason: [] }], updateSelectAndButtons })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rules])

    return {
        checkAll,
        buttonsCheked,
        isBlockNewComment,
        handleAddComment,
        handleDeleteComment,
        handleSaveComment,
        handleSelectChange
    }
}
